module.exports = __webpack_public_path__ + "static/doccommunity-a69b429442a27578f0a5de69eac66a4d.png";